const formValidation = (form, isEdit, files, setErrors, timelineMediaTypes) => {
    let errors = {};
    let isValid = true;

    //    Validate title
    if (!form.heading) {
        isValid = false;
        errors.heading = 'Heading is required';
    } else if (form.heading.length > 200) {
        isValid = false;
        errors.heading = 'Heading must be less than 200 characters long';
    }

    // Validate date
    if (!form.date) {
        isValid = false;
        errors.date = 'Date is required';
    }

    // validating media type
    if (!form.media_type_id) {
        isValid = false;
        errors.media_type_id = 'Media type is required';
    }

    // Validate description
    if (!form.event) {
        isValid = false;
        errors.event = 'Event is required';
    }

    // Get the selected media type - Fix the type comparison issue
    const selectedMediaType = timelineMediaTypes?.find(type => {
        return type.id == form.media_type_id;
    });
    const mediaTypeName = selectedMediaType?.name?.toLowerCase();



    // Conditional validation based on media type
    if (mediaTypeName === 'video' || mediaTypeName === 'audio') {
        // For Video or Audio: URL and thumbnail are required, file is not required
        if (!form.url) {
            isValid = false;
            errors.url = 'URL is required for video/audio content';
        } else if (!form.url.includes('https://') && !form.url.includes('http://')) {
            isValid = false;
            errors.url = 'URL must start with https:// or http://';
        }

        // Validate thumbnail (required for video/audio)
        if (!isEdit && !files.thumbnail) {
            isValid = false;
            errors.thumbnail = 'Thumbnail is required for video/audio content';
        } else if (files.thumbnail) {
            // Validate file type for thumbnail
            const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedImageTypes.includes(files.thumbnail.type)) {
                isValid = false;
                errors.thumbnail = 'Thumbnail must be a JPEG or PNG image';
            }

            // Validate file size (max 5MB)
            const maxImageSize = 5 * 1024 * 1024; // 5MB
            if (files.thumbnail.size > maxImageSize) {
                isValid = false;
                errors.thumbnail = 'Thumbnail file size must be less than 5MB';
            }
        }

        // File is not required for video/audio, but if provided, validate it
        if (files.manual) {
            // Validate file type for manual
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowedTypes.includes(files.manual.type)) {
                isValid = false;
                errors.manual = 'Manual must be a PDF or Word document';
            }

            // Validate file size (max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (files.manual.size > maxSize) {
                isValid = false;
                errors.manual = 'Manual file size must be less than 10MB';
            }
        }

    } else if (mediaTypeName === 'document') {
        // For Document: thumbnail and file are required
        if (!isEdit && !files.thumbnail) {
            isValid = false;
            errors.thumbnail = 'Thumbnail is required for document content';
        } else if (files.thumbnail) {
            // Validate file type for thumbnail
            const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedImageTypes.includes(files.thumbnail.type)) {
                isValid = false;
                errors.thumbnail = 'Thumbnail must be a JPEG or PNG image';
            }

            // Validate file size (max 5MB)
            const maxImageSize = 5 * 1024 * 1024; // 5MB
            if (files.thumbnail.size > maxImageSize) {
                isValid = false;
                errors.thumbnail = 'Thumbnail file size must be less than 5MB';
            }
        }

        // Validate manual file (required for documents)
        if (!isEdit && !files.manual) {
            isValid = false;
            errors.manual = 'File is required for document content';
        } else if (files.manual) {
            // Validate file type for manual
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowedTypes.includes(files.manual.type)) {
                isValid = false;
                errors.manual = 'Manual must be a PDF or Word document';
            }

            // Validate file size (max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (files.manual.size > maxSize) {
                isValid = false;
                errors.manual = 'Manual file size must be less than 10MB';
            }
        }

        // URL is optional for documents, but if provided, validate it
        if (form.url && !form.url.includes('https://') && !form.url.includes('http://')) {
            isValid = false;
            errors.url = 'URL must start with https:// or http://';
        }

    } else if (mediaTypeName === 'image') {
        // For Image: thumbnail and file are required
        if (!isEdit && !files.thumbnail) {
            isValid = false;
            errors.thumbnail = 'Thumbnail is required for image content';
        } else if (files.thumbnail) {
            // Validate file type for thumbnail
            const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedImageTypes.includes(files.thumbnail.type)) {
                isValid = false;
                errors.thumbnail = 'Thumbnail must be a JPEG or PNG image';
            }

            // Validate file size (max 5MB)
            const maxImageSize = 5 * 1024 * 1024; // 5MB
            if (files.thumbnail.size > maxImageSize) {
                isValid = false;
                errors.thumbnail = 'Thumbnail file size must be less than 5MB';
            }
        }

        // Validate manual file (required for images)
        if (!isEdit && !files.manual) {
            isValid = false;
            errors.manual = 'File is required for image content';
        } else if (files.manual) {
            // Validate file type for manual (images)
            const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
            if (!allowedImageTypes.includes(files.manual.type)) {
                isValid = false;
                errors.manual = 'Image file must be a JPEG, PNG, GIF, or WebP image';
            }

            // Validate file size (max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (files.manual.size > maxSize) {
                isValid = false;
                errors.manual = 'Image file size must be less than 10MB';
            }
        }

        // URL is optional for images, but if provided, validate it
        if (form.url && !form.url.includes('https://') && !form.url.includes('http://')) {
            isValid = false;
            errors.url = 'URL must start with https:// or http://';
        }

    } else {
        // Default validation for other media types or when no media type is selected
        // Validate manual file (required for new entries, optional for edits)
        if (!isEdit && !files.manual) {
            isValid = false;
            errors.manual = 'Manual file is required';
        } else if (files.manual) {
            // Validate file type for manual
            const allowedTypes = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
            if (!allowedTypes.includes(files.manual.type)) {
                isValid = false;
                errors.manual = 'Manual must be a PDF or Word document';
            }

            // Validate file size (max 10MB)
            const maxSize = 10 * 1024 * 1024; // 10MB
            if (files.manual.size > maxSize) {
                isValid = false;
                errors.manual = 'Manual file size must be less than 10MB';
            }
        }

        // Validate thumbnail file (optional but if provided, validate type and size)
        if (!isEdit && !files.thumbnail) {
            isValid = false;
            errors.thumbnail = 'Thumbnail is required';
        } else if (files.thumbnail) {
            // Validate file type for thumbnail
            const allowedImageTypes = ['image/jpeg', 'image/jpg', 'image/png'];
            if (!allowedImageTypes.includes(files.thumbnail.type)) {
                isValid = false;
                errors.thumbnail = 'Thumbnail must be a JPEG or PNG image';
            }

            // Validate file size (max 5MB)
            const maxImageSize = 5 * 1024 * 1024; // 5MB
            if (files.thumbnail.size > maxImageSize) {
                isValid = false;
                errors.thumbnail = 'Thumbnail file size must be less than 5MB';
            }
        }

        // URL validation (optional but if provided, validate format)
        if (form.url && !form.url.includes('https://') && !form.url.includes('http://')) {
            isValid = false;
            errors.url = 'URL must start with https:// or http://';
        }
    }

    setErrors(errors);
    return isValid;
};

export default formValidation;